/* eslint-disable import/prefer-default-export */
import store from '@/store'
import { ref } from '@vue/composition-api'

//* Method to fill param request from table 'facturacion'
export const configTableFacturacion = () => {
  //* This will be our table columns => { key: 'name of the object propiety', label: 'how to show in table' }
  const tableColumns = [
    { key: 'id', label: '#ID', sortable: true },
    { key: 'actions' },
    { key: 'show_details', label: 'Detalles' },
    { key: 'referencia', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    // { key: 'forma_pago', sortable: true },
    {
      key: 'monto', label: 'Aportación', sortable: true, formatter: val => `$${val}`,
    },
    { key: 'fecha_pago', sortable: true },
    { key: 'factura', sortable: false },
    // { key: 'observaciones', sortable: false },
    // { key: 'fechaAprobAdmin', label: 'Solicitado' },
    // { key: 'fechAprobContab', label: 'Facturado' },
    // { key: 'fac_observaciones', label: 'Check Contable' },
  ]
  //* Params to fill table data & filters
  const configRequest = ref({
    status: null, //* Filter
    wsParams: {
      action: 22, token: store.state.cuenta.session.token, rol: store.state.cuenta.rolSelected.id, plan: null,
    }, //* Request params
    wsType: 'wscompras', //* WebService name
    filterGetter: 'compras/filterFactura', //* filter de factura
  })

  return { tableColumns, configRequest }
}
